import { render, staticRenderFns } from "./AssessmentSpine.vue?vue&type=template&id=0baba815&scoped=true"
import script from "./AssessmentSpine.vue?vue&type=script&lang=js"
export * from "./AssessmentSpine.vue?vue&type=script&lang=js"
import style0 from "./AssessmentSpine.vue?vue&type=style&index=0&id=0baba815&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baba815",
  null
  
)

export default component.exports